const ORIGIN_MAP = {
  pwa: 'Credere',
  web: 'Credere',
  public_simulator: 'Showroom Digital',
  embed: '<embed>',
  pnp: 'Seu site',
};

export default function origin(entity) {
  let mapping;

  if (entity && entity.application && entity.application.name) {
    mapping = entity.application.name;
  } else if (entity && entity.payload && entity.payload.origin) {
    mapping = entity.payload.origin;
  }

  mapping = ORIGIN_MAP[mapping] || mapping;

  return mapping === 'Credere' ? null : mapping;
}
